export const TRANSACTION_ITEM_TYPE = {
  PRODUCT: "product",
  BOOKING: "booking",
} as const;

export const TRANSACTION_TIMELINE_EVENT = {
  DELIVERED: "delivered",
  COMPLETED: "completed",
  REFUND_INITIATED: "refund_initiated",
  REFUNDED: "refunded",
} as const;

export const TRANSACTION_TYPE = {
  BOOKING: "booking",
  PRODUCT: "product",
  MIXED: "mixed",
  SERVICE: "service",
  SUBSCRIPTION: "subscription",
} as const;

export const TRANSACTION_TYPE_OPTIONS = [
  { value: "", label: "All Types" },
  { value: TRANSACTION_TYPE.BOOKING, label: "Booking" },
  { value: TRANSACTION_TYPE.PRODUCT, label: "Product" },
  { value: TRANSACTION_TYPE.MIXED, label: "Mixed" },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: "", label: "All Methods" },
  { value: "card", label: "Card" },
  { value: "upi", label: "UPI" },
  { value: "wallet", label: "Wallet" },
  { value: "banktransfer", label: "Bank Transfer" },
];

export const PAYMENT_STATUS = {
  PAID: "paid",
  PENDING: "pending",
  FAILED: "failed",
  REFUNDED: "refunded",
} as const;

/** @deprecated use PAYMENT_STATUS — kept for existing imports */
export const PAYMENT_STATUS_FILTER = PAYMENT_STATUS;

export const PAYMENT_STATUS_OPTIONS = [
  { value: "", label: "All Status" },
  { value: PAYMENT_STATUS.PAID, label: "Paid" },
  { value: PAYMENT_STATUS.PENDING, label: "Pending" },
  { value: PAYMENT_STATUS.FAILED, label: "Failed" },
  { value: PAYMENT_STATUS.REFUNDED, label: "Refunded" },
];

export const PAYMENT_STATUS_LABEL: Record<string, string> = {
  [PAYMENT_STATUS.PAID]: "Paid",
  [PAYMENT_STATUS.PENDING]: "Pending",
  [PAYMENT_STATUS.FAILED]: "Failed",
  [PAYMENT_STATUS.REFUNDED]: "Refunded",
};

export const TRANSACTION_TYPE_LABEL: Record<string, string> = {
  [TRANSACTION_TYPE.BOOKING]: "Booking",
  [TRANSACTION_TYPE.PRODUCT]: "Product",
  [TRANSACTION_TYPE.MIXED]: "Mixed",
  [TRANSACTION_TYPE.SERVICE]: "Service",
  [TRANSACTION_TYPE.SUBSCRIPTION]: "Subscription",
};

export const TRANSACTION_TYPE_BADGE: Record<string, string> = {
  [TRANSACTION_TYPE.BOOKING]: "light-primary",
  [TRANSACTION_TYPE.PRODUCT]: "light-success",
  [TRANSACTION_TYPE.SERVICE]: "light-info",
  [TRANSACTION_TYPE.SUBSCRIPTION]: "light-warning",
  [TRANSACTION_TYPE.MIXED]: "light-secondary",
};

export const PAYMENT_STATUS_BADGE: Record<string, string> = {
  [PAYMENT_STATUS.PAID]: "light-success",
  [PAYMENT_STATUS.PENDING]: "light-warning",
  [PAYMENT_STATUS.FAILED]: "light-danger",
  [PAYMENT_STATUS.REFUNDED]: "light-secondary",
};

export const normalizePaymentStatus = (status?: string | null) =>
  status?.toLowerCase() ?? "";

export const normalizeTransactionType = (type?: string | null) =>
  type?.toLowerCase() ?? "";

export const formatPaymentStatus = (status?: string | null) =>
  PAYMENT_STATUS_LABEL[normalizePaymentStatus(status)] ?? status ?? "N/A";

export const formatTransactionType = (type?: string | null) =>
  TRANSACTION_TYPE_LABEL[normalizeTransactionType(type)] ?? type ?? "N/A";

export const getPaymentStatusBadgeColor = (status?: string | null) =>
  PAYMENT_STATUS_BADGE[normalizePaymentStatus(status)] ?? "light-secondary";

export const getTransactionTypeBadgeColor = (type?: string | null) =>
  TRANSACTION_TYPE_BADGE[normalizeTransactionType(type)] ?? "light-secondary";

export const PAYMENT_METHOD_LABEL: Record<string, string> = {
  card: "Card",
  upi: "UPI",
  wallet: "Wallet",
  banktransfer: "Bank Transfer",
};

export const formatPaymentMethod = (method?: string | null) => {
  const key = method?.toLowerCase() ?? "";
  return PAYMENT_METHOD_LABEL[key] ?? method ?? "N/A";
};
